export { default as PickerDetail } from './picker-detail';
